import type { IconProps } from "@phosphor-icons/react";
import { forwardRef } from "react";

export const WormLightIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", weight, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="100%"
        height="100%"
        fill="none"
        {...props}
      >
        <title>worm light icon</title>
        <path
          fill={color}
          d="M27 22.25V10.262l-1.719-.243-1.944-.275A3.885 3.885 0 0 1 20 5.894 3.895 3.895 0 0 1 23.894 2H26.4A3.6 3.6 0 0 1 30 5.6v16.65A7.749 7.749 0 0 1 22.25 30a7.749 7.749 0 0 1-7.75-7.75V20a5 5 0 0 0-5-5A4.498 4.498 0 0 0 5 19.5v9c0 .831-.669 1.5-1.5 1.5S2 29.331 2 28.5v-9C2 15.356 5.356 12 9.5 12a8 8 0 0 1 8 8v2.25A4.748 4.748 0 0 0 22.25 27 4.748 4.748 0 0 0 27 22.25ZM23.894 0a5.893 5.893 0 0 0-.838 11.725L25 12v10.25a2.75 2.75 0 1 1-5.5 0V20c0-5.525-4.475-10-10-10C4.256 10 0 14.256 0 19.5v9C0 30.431 1.569 32 3.5 32S7 30.431 7 28.5v-9A2.5 2.5 0 0 1 9.5 17c1.656 0 3 1.344 3 3v2.25A9.747 9.747 0 0 0 22.25 32 9.746 9.746 0 0 0 32 22.25V5.6C32 2.506 29.494 0 26.4 0h-2.506ZM25.5 7a1.507 1.507 0 0 0 1.061-.439 1.507 1.507 0 0 0 0-2.122 1.507 1.507 0 0 0-2.122 0 1.507 1.507 0 0 0 0 2.122A1.507 1.507 0 0 0 25.5 7Z"
        />
      </svg>
    );
  },
);
